/* eslint-disable react/function-component-definition */
import React, { useContext, useEffect, useState } from 'react';
import { UnVerifiedModal } from '@madeeasy/universal-login';
import { usePathname, useSearchParams } from 'next/navigation';
import { HeaderContext } from '../../contexts/headerContext';
import { checkProfileIncomplete } from '../../utils/helpers';
import { useUser } from '../../contexts/ssr-user-context';

/**
 * Global verification check component that displays popup
 * when user has unverified email or mobile number.
 * This runs once on app mount for authenticated users.
 */
const VerificationCheck = () => {
  const { user } = useUser();
  const { setUnverifiedField } = useContext(HeaderContext);
  const [showUnVerifiedPopUp, setShowUnVerifiedPopUp] = useState(false);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isPrefixed = process.env.NEXT_PUBLIC_USE_BASE_PATH === 'true';

  const handleKeepUserOnTheSamePage = () => {
    const params = new URLSearchParams(searchParams.toString());
    params.set('noRedirect', true);
    const newUrl = `${isPrefixed ? '/prep' : ''}${pathname}?${params.toString()}`;
    window.history.replaceState(null, '', newUrl);
  };

  useEffect(() => {
    // Only check if user is authenticated (has a name)
    if (user?.name && user.name !== '') {
      const checkUserIncompleteProfile = checkProfileIncomplete();

      if (checkUserIncompleteProfile !== null) {
        if (checkUserIncompleteProfile.mobile === false) {
          setShowUnVerifiedPopUp(true);
          setUnverifiedField('mobile');
          handleKeepUserOnTheSamePage();
        } else if (checkUserIncompleteProfile.email === false) {
          setShowUnVerifiedPopUp(true);
          setUnverifiedField('email');
          handleKeepUserOnTheSamePage();
        }
      }
    }
  }, [user?.name, setUnverifiedField]);

  // Only render the modal if needed
  if (!showUnVerifiedPopUp) {
    return null;
  }

  return <UnVerifiedModal toggleModal text="Verify" />;
};

export default VerificationCheck;
